<template>
  <stacked-bar :chart-data="chartData" :loading="loading" chart-v-ax-format="R#,###.##" :bus="bus"></stacked-bar>
</template>

<script>
import StackedBar from "../../../charts/StackedBar";
import Vue from "vue";

export default {
  name: "FulfillmentValue",
  data() {
    return {
      loading: false
    }
  },
  props: ['date-range', 'updateData', 'view-data', 'bus'],
  components: {StackedBar},
  computed: {
    chartData: function() {
      return this.viewData
    }
  }
}
</script>

<style scoped>

</style>
